export const VIEW_WIDTH_CSS_VAR = '--ws-editor-view-width';
export const VIEW_BORDER_CSS_VAR = '--ws-editor-view-border';
// Width of the panel docked to the right edge of the editor. Consumed by the
// view, the view overlay and the overlay positioning helpers; written by the
// module that owns the docked panel (currently `ai-chat`).
export const PANEL_WIDTH_CSS_VAR = '--ws-editor-panel-width';
